module.exports = __webpack_public_path__ + "static/media/icon-daily-login.18867ef0.svg";